import type { TFunction } from 'i18next'

/** URL d'un document joint (cookie de session ; PDF affichable en ligne). */
export function attachmentUrl(householdId: string, attachmentId: string) {
  return `/api/v1/households/${householdId}/attachments/${attachmentId}`
}

export function formatFileSize(bytes: number, t: TFunction) {
  if (bytes >= 1_000_000) return t('inventory.fileSizeMb', { size: (bytes / 1_000_000).toFixed(1) })
  return t('inventory.fileSizeKb', { size: Math.max(1, Math.round(bytes / 1000)) })
}
